import $http from '@common-vue/bag-checkout-common-consumable/src/services/http';
import logger from '@core/util/universal-logger';

export async function fetchPageData({ dataUrl, pageDataApiTimeout }) {
  let url = dataUrl;
  const { userAgent = '' } = navigator;

  // UA-sniff Safari: https://stackoverflow.com/questions/7944460/detect-safari-browser
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent)
  // some user agent strings do not have the word 'Safari'
  || !!window.safari // only desktop has this object
  || (/Mac OS/i.test(userAgent) === true && /chrome|android|firefox/i.test(userAgent) === false); // Apple non Chrome and Firefox
  if (isSafari) {
    if (url.indexOf('?') === -1) {
      url += '?';
    }

    url += '&safari=true';
  }

  const timeout = Number(pageDataApiTimeout) || 5000;

  const { data, headers } = await $http.get(url, {
    timeout,
    getHeaders: true,
    // For 'fetch' preloading to work, we need to pass the following values. Changing these will break the preloading functionality
    credentials: 'include',
    mode: 'no-cors',
    sendFingerPrintHeader: true,
  });
  return { data, headers };
}
/**
 * Gets headerFooter chunks as json object
 * @returns { Object } { cssChunks: [], jsChunks:[] }
 */

export async function fetchApplePay({ payload }) {
  const { data, headers } = await $http.post('/chkout/orderconfirmation/applepay?showOrderConfirmation=true',
    payload,
    {
      timeout: 75000, // 75000 HTTP_REQUEST_TIMEOUT in my-checkout-consumable
      // since PageDateService a common file, not importing this value from my-checkout-consumable
      // Later when refactoring is done through app.vue/internal_routes, import from my-checkout-consumable
      getHeaders: true,
      sendFingerPrintHeader: true,
    });
  return { data, headers };
}

export async function fetchSTSData({ dataUrl }) {
  try {
    const { data, headers } = await fetchPageData({ dataUrl, pageDataApiTimeout: 75000 });
    return { data, headers };
  } catch (error) {
    logger.error('Error while fetching STS Data', error);
    // Setting with empty object as user is shown some info with static message and url when API Fails
    return { data: {} };
  }
}
